<template>
  <div>
    <div class="newContent">
      <div class="navContnet">
        <div class="flex row-bottom">
          <div class="row-content" style="width: 75px;">项目名称</div>
          <div class="row-content">
            {{ graphic.name }}
          </div>
        </div>
        <div class="flex row-bottom">
          <div class="row-content" style="width: 75px;">实施主体</div>
          <div class="row-content">
            {{ graphic.orgCompanyName }}
          </div>
        </div>
        <div class="flex row-bottom">
          <div class="row-content" style="width: 75px;">项目分类</div>
          <div class="row-content">
            {{ graphic.dataProjectTypeId.name }}
          </div>
        </div>
        <div class="flex row-bottom">
          <div class="row-content" style="width: 75px;">项目金额</div>
          <div class="row-content">
            <span class="num">{{
              graphic.planFundProvince +
                graphic.planFundCity +
                graphic.planFundOther
            }}</span>
            <span class="wy">万元</span>
          </div>
        </div>
        <div class="flex">
          <div class="row-content" style="width: 75px;">计划时间</div>
          <div class="row-content">
            <span class="num">
              {{ $formatDate(new Date(graphic.bdate), "yyyy-MM-dd") }}
            </span>
            -
            <span class="num">
              {{ $formatDate(new Date(graphic.edate), "yyyy-MM-dd") }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 10) {
        return value.slice(0, 10) + "...";
      }
      return value;
    }
  },
  computed: {
    ...mapGetters(["graphic"])
  }
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.wy
  font-size 0.06rem
.newContent
  height calc(100% - 43px)
  margin 5px 0
.navTitle
  position relative
.iconImg
  height 25px
.navName
  position absolute
  color #fff
  font-size 13px
  vertical-align top
  line-height 25px
  left 30px
.navContnet
  border 1px solid #03A9C8
  color #fff
  font-size 14px
.row-bottom
  border-bottom 1px solid #03A9C8
.row-content
  height 30px
  line-height 30px
  padding-left 10px
.row-content:nth-child(1)
  border-right 1px solid #03A9C8
.num
  color $textColor
  font-size 18px
.navContent
  height calc(100% - 28px)
@media (max-width 1280px)
  .navContnet
    font-size 0.08rem
  .num
    font-size 0.12rem
  .wy
    font-size 0.08rem
</style>
